

import { StyleValue } from '@/shared/app/model/StyleValue';
import Base from '@/shared/app/ui/Base.vue';
import { Component } from 'vue-property-decorator';

@Component
export default class Time extends Base {
  forceUpdateInterval = -1;
  forceUpdate = true;

  mounted() {
    if (this.realtime) this.realtime.subscribeToDatasets([{ name: 'time', alias: 'time' }]);
    this.forceUpdateInterval = setInterval(() => {
      this.forceUpdate = !this.forceUpdate;
    }, 1000);
  }

  beforeUnmount() {
    clearInterval(this.forceUpdateInterval);
  }

  get style(): StyleValue {
    return {
      fontFamily: this.config.fontFamily?.toString() || 'sans-serif',
      fontSize: this.config.fontSize?.toString() || '2em',
      fontWeight: this.config.fontWeight?.toString() || 'bold',
      color: this.config.color?.toString() || 'white',

      backgroundColor: this.config.backgroundColor?.toString() || 'transparent',
      padding: this.config.padding?.toString() || '1rem 1.5rem',
    };
  }

  get fullTime() {
    return this.date.toLocaleString('fr-FR', {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: this.tz
    })
  }

  get hours() {
    return this.fullTime.split(':')[0];
  }

  get minutes() {
    return this.fullTime.split(':')[1];
  }

  get date() {
    // eslint-disable-next-line no-unused-expressions
    this.forceUpdate;
    const iso8601 = this.timeDataset.iso8601?.toString();
    if (iso8601) return new Date(iso8601);
    return new Date();
  }

  get timeDataset() {
    return this.dataset('time');
  }

  get tz() {
    return this.timeDataset.tz?.toString() || 'Europe/Paris';
  }
}
